const { sameWithMultiPath } = require('../utils');
const { DEFAULT_TEXT_BODY_STYLE } = require('../../Shape/AbstractShape/config/defaultStyles');

exports.computeAutoFitTextFromTextBodies = textBodies => sameWithMultiPath(textBodies, ['autoFitText', 'assignedStyles.textBody.autoFitText'], DEFAULT_TEXT_BODY_STYLE.autoFitText, { skipUndefined: false });
